import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [logo, setLogo] = useState("");
  const nav = useNavigate();
  useEffect(() => { api.get("/settings").then((r) => setLogo(r.data.logo_file_id || "")).catch(() => {}); }, []);
  const NavLink = ({ to, children }) => (
    <a href={to} onClick={(e) => { e.preventDefault(); setOpen(false); if (to.startsWith("#")) { document.querySelector(to)?.scrollIntoView({ behavior: "smooth" }); } else { nav(to); } }}
       className="text-sm uppercase tracking-widest text-white/80 hover:text-[#39FF14] transition-colors">
      {children}
    </a>
  );
  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 backdrop-blur-2xl bg-[#050505]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          {logo ? (
            <img src={fileUrl(logo)} alt="NDPL" className="w-11 h-11 rounded-full object-cover ring-1 ring-[#FFD700]/40" />
          ) : (
            <div className="w-9 h-9 rounded-md bg-[#39FF14] text-black grid place-items-center font-display text-xl">N</div>
          )}
          <div className="leading-none">
            <div className="font-display text-2xl text-white">NDPL</div>
            <div className="text-[10px] tracking-[0.3em] text-[#FFD700]">T10 PREMIER LEAGUE</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="#about">About</NavLink>
          <NavLink to="#prize">Prize Pool</NavLink>
          <NavLink to="/selected-players">Selected Players</NavLink>
          <NavLink to="#gallery">Gallery</NavLink>
          <NavLink to="#sponsors">Sponsors</NavLink>
          <NavLink to="#faqs">FAQs</NavLink>
          <NavLink to="#contact">Contact</NavLink>
          <a href="/register" data-testid="nav-register" className="px-5 py-2 bg-[#39FF14] text-black font-bold uppercase text-xs tracking-widest hover:bg-white transition-colors">Register ₹799</a>
          <a href="/player/login" data-testid="nav-player-login" className="text-xs uppercase tracking-widest text-[#FFD700] border border-[#FFD700]/40 px-4 py-2 hover:bg-[#FFD700] hover:text-black transition-colors">Player Login</a>
        </nav>
        <button onClick={() => setOpen(!open)} className="md:hidden text-white" data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#0B132B] border-t border-white/10 px-6 py-4 space-y-3">
          <NavLink to="#about">About</NavLink><br/>
          <NavLink to="#prize">Prize Pool</NavLink><br/>
          <NavLink to="/selected-players">Selected Players</NavLink><br/>
          <NavLink to="#gallery">Gallery</NavLink><br/>
          <NavLink to="#sponsors">Sponsors</NavLink><br/>
          <NavLink to="#faqs">FAQs</NavLink><br/>
          <NavLink to="#contact">Contact</NavLink>
          <div className="pt-3 flex gap-3">
            <a href="/register" className="flex-1 text-center px-4 py-2 bg-[#39FF14] text-black font-bold uppercase text-xs tracking-widest">Register</a>
            <a href="/player/login" className="flex-1 text-center px-4 py-2 border border-[#FFD700] text-[#FFD700] uppercase text-xs">Login</a>
          </div>
        </div>
      )}
    </header>
  );
}
